import React, { useState } from 'react';
import Navbar from '../../Navbar/Navbar';
import axios from 'axios';
import baseURL from '../../config';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";


const ExecutiveForm = () => {
  const { id } = useParams();
  const navigate= useNavigate()
    
  // Define state for form fields
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyId: id,
  });

  const [error, setError] = useState('');

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, phoneNumber, email, password, confirmPassword, companyId } = formData;

    // Validate fields
    if (!name || !phoneNumber || !email || !password || !confirmPassword ) {
      setError('All fields are required');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    // If all validations pass
    setError('');
   
    // Handle form submission logic here (e.g., send data to server)
    try{
        const response= axios.post(`${baseURL}/api/ExecutiveDetail`,formData )
        if (response.status === 200 || response.status === 201) {
            toast.success(formData._id ? "Crewing Agent details updated successfully!" : "Crewing Agent details submitted successfully!");
        }
        navigate(`/ExecutiveTable/${id}`)
    }catch (error) {
      toast.error(error.response?.data?.message || "Unexpected error occurred!");
    }
  };

  return (
    <>
    <Navbar />
    <div className="ExecutiveformContainer">
      <h2>Executive Form</h2>
      <form onSubmit={handleSubmit}>
        {/* Name of Executive */}
        <div className="inputGroup">
          <label htmlFor="name">Name of Executive</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Phone Number */}
        <div className="inputGroup">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Email */}
        <div className="inputGroup">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Password */}
        <div className="inputGroup">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Confirm Password */}
        <div className="inputGroup">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* Display error if any */}
        {error && <p style={{ color: 'red' }}>{error}</p>}

        {/* Submit Button */}
        <button type="submit">Submit</button>
      </form>
    </div>
    <ToastContainer />
    </>
  );
};

export default ExecutiveForm;
